import { request, toQuery, unwrap } from '../client';
import type {
  ApiResponse,
  PagedResponse,
  PageParams,
  UserSummaryDto,
  UserTenantDto,
} from '../types';

const BASE = '/api/saas-admin/users';

export const usersApi = {
  /**
   * SASATH-0212 — server-paged/searched user read, and the ONLY user list read:
   * the pre-0212 full-array `list()` was removed in SASADM-0106 U2 once its last
   * consumer (`CommandPalette`) moved to server search. The user table is far too
   * large to full-fetch; do not reintroduce one. `q` is a case-insensitive
   * contains match over email + name, evaluated by the server; empty params
   * are omitted so an empty `q` is never sent.
   */
  async listPaged(params: PageParams = {}): Promise<PagedResponse<UserSummaryDto>> {
    const res = await request<ApiResponse<PagedResponse<UserSummaryDto>>>('GET', BASE, {
      query: toQuery({ page: params.page, size: params.size, q: params.q }),
    });
    return unwrap(res);
  },

  async get(id: number): Promise<UserSummaryDto> {
    const res = await request<ApiResponse<UserSummaryDto>>('GET', `${BASE}/${id}`);
    return unwrap(res);
  },

  async tenants(id: number): Promise<UserTenantDto[]> {
    const res = await request<ApiResponse<UserTenantDto[]>>('GET', `${BASE}/${id}/tenants`);
    return unwrap(res);
  },
};
